






































import { Vue, Component, Prop } from "vue-property-decorator";

import TheSimpleHeader from "@/common/components/organisms/TheSimpleHeader.vue";
import TheFooter from "@/common/components/organisms/TheFooter.vue";
import CommonHeading from "@/common/components/atoms/CommonHeading.vue";
import ButtonMain from "@/common/components/atoms/ButtonMain.vue";

import commons from "@/common/store/modules/commons";
import LocalStorage from "@/general/utils/storage";

@Component({
  components: {
    TheSimpleHeader,
    TheFooter,
    CommonHeading,
    ButtonMain
  }
})
export default class ThePageError extends Vue {
  @Prop({ type: Object, required: true }) errorData!: any;

  // errorType - error, service or maintenance
  @Prop({ type: String, default: "error" }) errorType!: any;

  get errorTitleText() {
    let title = this.errorData.title;

    if (
      this.errorType === "maintenance" &&
      LocalStorage.getItem("MAINTENANCE_TITLE")
    ) {
      title = LocalStorage.getItem("MAINTENANCE_TITLE") as string;
    } else if (
      this.errorType === "service" &&
      LocalStorage.getItem("SERVICE_TITLE")
    ) {
      title = LocalStorage.getItem("SERVICE_TITLE") as string;
    }

    return title;
  }

  get errorSubTitleText() {
    return this.errorData.subTitle;
  }

  get errorMessageTexts() {
    let message = this.errorData.message;

    if (
      this.errorType === "maintenance" &&
      LocalStorage.getItem("MAINTENANCE_MESSAGE")
    ) {
      message = LocalStorage.getItem("MAINTENANCE_MESSAGE") as string;
    } else if (
      this.errorType === "service" &&
      LocalStorage.getItem("SERVICE_MESSAGE")
    ) {
      message = LocalStorage.getItem("SERVICE_MESSAGE") as string;
    }

    return message.split("\n");
  }

  get errorButtonText() {
    return this.errorData.button.label;
  }

  buttonAction() {
    if (this.errorData.button.action === "closeWindow") {
      window.close();
    } else if (this.errorData.button.action === "toLoginPage") {
      window.location.href = commons.LOGIN_URL;
    }
  }
}
